import script from "./CreateTournamentView.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateTournamentView.vue?vue&type=script&lang=ts&setup=true"

import "./CreateTournamentView.vue?vue&type=style&index=0&id=2f42a064&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f42a064"]])

export default __exports__